import React, { useState } from 'react';

export interface Employee {
  id: string;
  name: string;
  initials: string;
  color: string;
  profilePic?: string;
  bio?: string;
}

interface NavbarProps {
  selectedEmployee: Employee;
  onEmployeeChange: (employee: Employee) => void;
  employees: Employee[];
  onResetPackage?: () => void;
  hideEmployeeSelector?: boolean;
  onLogout?: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ 
  selectedEmployee, 
  onEmployeeChange, 
  employees, 
  onResetPackage, 
  hideEmployeeSelector = false,
  onLogout
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-logo">
          <img 
            src="/Logo.png" 
            alt="Dashboard Logo"
            className="logo-image"
          />
        </div>
        <div className="navbar-right">
          <div className="account-manager">
            {selectedEmployee.profilePic ? (
              <div className="profile-icon">
                <img 
                  src={selectedEmployee.profilePic} 
                  alt={selectedEmployee.name}
                  className="profile-image"
                />
              </div>
            ) : null}
            {!hideEmployeeSelector ? (
              <div className="employee-dropdown">
                <button 
                  className="employee-selector"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <span className="account-name">{selectedEmployee.name}</span>
                  <svg 
                    className={`dropdown-arrow ${isDropdownOpen ? 'expanded' : ''}`}
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                
                {isDropdownOpen && (
                  <div className="employee-dropdown-menu">
                    {employees.map((employee) => (
                      <button
                        key={employee.id}
                        className={`employee-option ${selectedEmployee.id === employee.id ? 'selected' : ''}`}
                        onClick={() => {
                          onEmployeeChange(employee);
                          setIsDropdownOpen(false);
                        }}
                      >
                        {employee.profilePic ? (
                          <div className="employee-avatar">
                            <img 
                              src={employee.profilePic} 
                              alt={employee.name}
                              className="employee-image"
                            />
                          </div>
                        ) : null}
                        <span>{employee.name}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="employee-display">
                <span className="account-name">{selectedEmployee.name}</span>
              </div>
            )}
          </div>
          
          <div className="navbar-actions">
          {onResetPackage && (
            <button 
              className="reset-package-button"
              onClick={onResetPackage}
              title="Nieuw pakket starten"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4V10H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M23 20V14H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Restart</span>
            </button>
          )}
            {onLogout && (
              <button 
                className="logout-button"
                onClick={onLogout}
                title="Uitloggen"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Uitloggen</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
